import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Error404 from "./components/Error404/Error404";

import Armonizacion from './components/Armonizacion/Armonizacion';
import ArmonizacionDetalle from './components/Armonizacion/ArmonizacionDetalle';
import Servicios from './components/Servicios/Servicios';
import Boletin from './components/Boletin/Boletin';
import S1 from './components/S1/S1';
import S2 from './components/S2/S2';
import C1 from './components/C1/C1';
import Ed from './components/Ed/Ed';
import Ed2026 from './components/Ed/Ed2026';
import Pr from './components/Ed/Pr';
import Pr2026 from './components/Ed/Pr2026';
import Ev from './components/Ed/Ev';
import Ev2026 from './components/Ed/Ev2026';
import Evgral from './components/Evgral/Evgral';
import Funciones from "./components/Funciones/Funciones";
import Informacion from "./components/Informacion/informacion";

import ServiciosDetalle from './components/Servicios/ServiciosDetalle';


function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/Transparencia" element={ <Transparencia/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="/Armonizacion" element={ <Armonizacion/> } />
          <Route exact path="/Armonizacion/DetalleArmonizacion/:children" element={ <ArmonizacionDetalle/> } />
          <Route exact path="/Servicios" element={ <Servicios/> } />
          <Route exact path="/Boletin" element={ <Boletin/> } />
          <Route exact path="/S1" element={ <S1/> } />
          <Route exact path="/S2" element={ <S2/> } />
          <Route exact path="/C1" element={ <C1/> } />
          <Route exact path="/Ed" element={ <Ed/> } />
          <Route exact path="/Ed2026" element={ <Ed2026/> } />
          <Route exact path="/Pr" element={ <Pr/> } />
          <Route exact path="/Pr2026" element={ <Pr2026/> } />
          <Route exact path="/Ev" element={ <Ev/> } />
          <Route exact path="/Ev2026" element={ <Ev2026/> } />
          <Route exact path="/Evgral" element={ <Evgral/> } />

          <Route exact path="/Servicios/DetalleServicios/:children" element={ <ServiciosDetalle/> } />
          <Route exact path="/funciones" element={ <Funciones /> } />
          <Route exact path="/informacion" element={ <Informacion /> } />
          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
